
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function StudyNotesPreview() {
  const benefits = [
    "Organize comprehensive study materials by topics and subjects",
    "Create searchable, categorized notes for quick reference",
    "Memory tricks and exam-focused study techniques",
    "Rich formatting with bullets, highlights, and sections",
    "Adaptive mode that focuses on your weak areas",
    "Quick revision mode for last-minute preparation"
  ];
  
  const screenshots = [
    {
      url: "/placeholder.svg",
      caption: "Study Notes - Comprehensive study materials with memory tricks"
    },
    {
      url: "/placeholder.svg",
      caption: "Detailed Study Materials - Rich content with key memory aids"
    }
  ];

  return (
    <FeatureShowcase
      title="Smart Study Notes"
      description="Create, organize and master comprehensive study materials with AI assistance."
      featureName="Study Notes"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
